import { isEmpty } from 'lodash-es';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetch_announcements,
	fetch_news_data,
	fetch_news_details,
	fetch_sector_list,
	fetch_sector_news_data,
} from '../../../apis/equity/newsAndAnnouncements';
import {
	fetchAnnouncements,
	fetchNewsData,
	fetchNewsDetails,
	fetchSectorList,
	fetchSectorNewsData,
	setAnnouncements,
	setNewsData,
	setSectorList,
	updateNewsDetails,
} from '../../reducers/equity/newsAndAnnouncements';
import { genericErrorMessage } from '../../../apis/common';
import { setLoader } from '../../reducers/loader';
import { setError } from '../../reducers/error';

function* handleFetchAnnouncements({ payload }) {
	const { data, Api } = payload;
	try {
		yield put(
			setAnnouncements({
				isLoading: true,
				isFetchFailed: false,
				error: null,
			}),
		);
		const response = yield call(fetch_announcements, Api, data);
		if (!isEmpty(response?.get_announcements_data?.data)) {
			yield put(
				setAnnouncements({
					data: response.get_announcements_data.data,
					isFetchFailed: false,
					error: null,
				}),
			);
		} else {
			if (!isEmpty(response?.get_announcements_data?.error)) {
				throw new Error({
					message: response.get_announcements_data.error.message,
				});
			} else {
				throw new Error({
					message: genericErrorMessage,
				});
			}
		}
	} catch (error) {
		console.log('Announcements fetch error', error);
		yield put(
			setAnnouncements({
				isFetchFailed: true,
				error: { message: error?.message },
			}),
		);
	} finally {
		yield put(setAnnouncements({ isLoading: false }));
	}
}

function* handleFetchNewsDetails({ payload }) {
	const { screen, data, Api } = payload;
	try {
		yield put(setLoader({ screen, isPageLoading: true }));
		yield put(setError({ screen, isFetchFailed: false }));
		const response = yield call(fetch_news_details, Api, data);
		if (!isEmpty(response?.get_sector_wise_news_details?.data?.[0])) {
			yield put(
				updateNewsDetails(
					response.get_sector_wise_news_details.data?.[0],
				),
			);
		} else {
			if (!isEmpty(response?.get_sector_wise_news_details?.error)) {
				throw new Error({
					message:
						response.get_sector_wise_news_details.error.message,
				});
			} else {
				throw new Error({
					message: genericErrorMessage,
				});
			}
		}
	} catch (error) {
		console.log('News Details fetch error', error);
		yield put(setError({ screen, isFetchFailed: true }));
	} finally {
		yield put(setLoader({ screen, isPageLoading: false }));
	}
}

function* handleFetchNewsData({ payload }) {
	const { data, Api } = payload;
	try {
		yield put(
			setNewsData({ isLoading: true, isFetchFailed: false, error: null }),
		);
		const response = yield call(fetch_news_data, Api, data);
		if (!isEmpty(response?.get_news_data?.data)) {
			yield put(
				setNewsData({
					data: response?.get_news_data?.data,
					isFetchFailed: false,
					error: null,
				}),
			);
		} else {
			if (!isEmpty(response?.get_news_data?.error)) {
				throw new Error({
					message: response.get_news_data.error.message,
				});
			} else {
				throw new Error({
					message: genericErrorMessage,
				});
			}
		}
	} catch (error) {
		console.log('News Data fetch error', error);
		yield put(
			setNewsData({
				isFetchFailed: true,
				error: { message: error?.message },
			}),
		);
	} finally {
		yield put(setNewsData({ isLoading: false }));
	}
}

function* handleFetchSectorNewsData({ payload }) {
	const { data, Api } = payload;
	try {
		yield put(
			setNewsData({ isLoading: true, isFetchFailed: false, error: null }),
		);
		const response = yield call(fetch_sector_news_data, Api, data);
		if (!isEmpty(response?.get_sector_wise_news_data?.data)) {
			yield put(
				setNewsData({
					data: response.get_sector_wise_news_data.data,
					isFetchFailed: false,
					error: null,
				}),
			);
		} else {
			if (!isEmpty(response?.get_sector_wise_news_data?.error)) {
				throw new Error({
					message: response.get_sector_wise_news_data.error.message,
				});
			} else {
				throw new Error({
					message: genericErrorMessage,
				});
			}
		}
	} catch (error) {
		console.log('Sector News Data fetch error', error);
		yield put(
			setNewsData({
				isFetchFailed: true,
				error: { message: error?.message },
			}),
		);
	} finally {
		yield put(setNewsData({ isLoading: false }));
	}
}

function* handleFetchSectorList({ payload }) {
	const { Api } = payload;
	const data = {
		pno: 1,
		psize: 100,
	};
	try {
		yield put(
			setSectorList({
				isLoading: true,
				isFetchFailed: false,
				error: null,
			}),
		);
		const response = yield call(fetch_sector_list, Api, data);
		if (!isEmpty(response?.get_sector_list?.data)) {
			yield put(
				setSectorList({
					data: response.get_sector_list.data,
					isFetchFailed: false,
					error: null,
				}),
			);
		} else {
			if (!isEmpty(response?.get_sector_list?.error)) {
				throw new Error({
					message: response.get_sector_list.error.message,
				});
			} else {
				throw new Error({
					message: genericErrorMessage,
				});
			}
		}
	} catch (error) {
		console.log('Sector list fetch error', error);
		yield put(
			setSectorList({
				isFetchFailed: true,
				error: { message: error?.message },
			}),
		);
	} finally {
		yield put(setSectorList({ isLoading: false }));
	}
}

// Portfolio news feature parked for now

// function* handleFetchPortfolioNewsData({ payload }) {
// 	const { data } = payload;
// 	try {
// 		yield put(setPortfolioNewsData({ isLoading: true, isFetchFailed: false, error: null }));
// 		const response = yield call(fetch_portfolio_news_data, data);
// 		if (!isEmpty(response?.get_hot_pursuit_data?.data)) {
// 			yield put(setPortfolioNewsData({ data: response, isFetchFailed: false, error: null }));
// 		} else {
// 			if (!isEmpty(response?.get_hot_pursuit_data?.error)) {
// 				throw new Error({ message: response.get_hot_pursuit_data.error.message });
// 			} else {
// 				throw new Error({ message: STRINGS.COMMON.genericErrorMessage });
// 			}
// 		}
// 	} catch (error) {
// 		console.log('portfolio news fetch error', error);
// 		yield put(setPortfolioNewsData({ isFetchFailed: true, error: { message: error?.message } }));
// 	} finally {
// 		yield put(setPortfolioNewsData({ isLoading: false }));
// 	}
// }

export default function* newsAndAnnouncementsSaga() {
	// yield takeLatest(fetchPortfolioNewsData.toString(), handleFetchPortfolioNewsData);
	yield takeLatest(fetchAnnouncements.toString(), handleFetchAnnouncements);
	yield takeLatest(fetchNewsDetails.toString(), handleFetchNewsDetails);
	yield takeLatest(fetchSectorList.toString(), handleFetchSectorList);
	yield takeLatest(fetchNewsData.toString(), handleFetchNewsData);
	yield takeLatest(fetchSectorNewsData.toString(), handleFetchSectorNewsData);
}
